<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon
          left
          class="icon-style"
        >
          mdi-database-plus
        </v-icon>Adjust AI Credits
      </h2>
      <v-form ref="form">
        <v-container>
          <v-card-text class="text-body-1 text-center">
            <v-row class="fill-height">
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="amount"
                  :rules="amountRules"
                  label="Amount*"
                  outlined
                  persistent-hint
                  hint="Use a positive value to add credits, a negative value to deduct credits."
                  dense
                />
              </v-col>
            </v-row>
            <v-row class="fill-height">
              <v-col
                cols="12"
                md="12"
              >
                <v-textarea
                  v-model="description"
                  :rules="textRules"
                  label="Description"
                  height="80px"
                  filled
                />
              </v-col>
            </v-row>
            <v-row class="fill-height">
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="createdBy"
                  :rules="textRules"
                  label="Created By"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <br>
            <p class="text-sm-left">
              *Indicates required field
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="adjustAiCredits()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </v-dialog>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';

  export default {
    name: 'AdjustAiCredits',
    components: {
      'centre-spinner': spinner,
    },
    props: {
      organizationId: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        amount: '',
        description: '',
        createdBy: '',
        loading: false,
        showModal: true,
        amountRules: [
          (v) => (v !== null && v !== '' && v !== undefined) || 'This field is required',
          (v) => (!isNaN(parseFloat(v)) && isFinite(v)) || 'Amount must be a number',
          (v) => Number(v) !== 0 || 'Amount cannot be zero',
          (v) => (Number(v) >= -1000000 && Number(v) <= 1000000) || 'Amount must be between -1,000,000 and 1,000,000',
        ],
        textRules: [
          (v) => !v || v.length <= 255 || 'Max 255 characters',
        ],
      };
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      adjustAiCredits () {
        if (this.$refs.form.validate() === true) {
          this.loading = true;
          this.$store.dispatch('payments/updateAiCredits', {
            organizationId: this.organizationId,
            aiCreditsDetails: {
              amount: Number(this.amount),
              description: this.description || null,
              created_by: this.createdBy || null,
            },
          }).then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'AI credits updated successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.loading = false;
            this.$emit('fetch-ai-credits');
            this.showModal = false;
          }).catch(() => {
            this.loading = false;
          });
        }
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
</style>
